/** Folio visible: correlativo por tenant (numero_pedido), con fallback a id interno. */
export function formatPedidoFolio(pedido: {
  numero_pedido?: number | null;
  numero_pedido_format?: string | null;
  id_pedido?: number | null;
  id_pedido_format?: string | null;
} | null | undefined): string {
  if (!pedido) {
    return '';
  }
  if (pedido.numero_pedido_format) {
    return pedido.numero_pedido_format;
  }
  if (pedido.numero_pedido != null) {
    return `SL${String(pedido.numero_pedido).padStart(8, '0')}`;
  }
  if (pedido.id_pedido_format) {
    return pedido.id_pedido_format;
  }
  if (pedido.id_pedido != null) {
    return `SL${String(pedido.id_pedido).padStart(8, '0')}`;
  }
  return '';
}

/** Texto para filtro/búsqueda local: folio + números crudos. */
export function pedidoFolioSearchText(pedido: {
  numero_pedido?: number | null;
  numero_pedido_format?: string | null;
  id_pedido?: number | null;
  id_pedido_format?: string | null;
} | null | undefined): string {
  if (!pedido) {
    return '';
  }
  const parts = [formatPedidoFolio(pedido)];
  if (pedido.numero_pedido != null) {
    parts.push(String(pedido.numero_pedido));
  }
  if (pedido.id_pedido != null) {
    parts.push(String(pedido.id_pedido));
  }
  if (pedido.id_pedido_format) {
    parts.push(pedido.id_pedido_format);
  }
  return parts.join(' ').toLowerCase();
}
